const store = require('Store');
const getLithiumUserData = require('actions/UserActions').getLithiumUserData;
const Events = require('utils/framework/Events');

module.exports = (function () {
    Events.onLastLoadEvent(window, [Events.UserInfoReady], () => {
        const profile = store.getState().user;
        store.dispatch(getLithiumUserData({ profile: profile }));
    });
}());
